import { ReactComponent as XMarkRegularIcon } from "../../assets/icons/font-awesome/xmark-regular.svg";
import { ReactComponent as PlusRegularIcon } from "../../assets/icons/font-awesome/plus-regular.svg";

type TPopoverHeaderProps = {
  title: string;
  onCloseClick?: () => void;
  onCreateClick?: () => void;
  createCta?: string;
};

const PopoverHeader = ({
  title,
  onCloseClick,
  onCreateClick,
  createCta,
}: TPopoverHeaderProps) => {
  return (
    <>
      <div className="dr-flex dr-items-center dr-justify-between dr-px-16 dr-pt-16 dr-pb-8 w-full">
        <div className="flex dr-items-center dr-space-x-16">
          {onCloseClick && (
            <XMarkRegularIcon
              onClick={onCloseClick}
              className="w-14 dr-max-w-14 dr-cursor-pointer"
            />
          )}
          <div className="BodyBody1Bold">{title}</div>
        </div>
        {onCreateClick ? (
          <div
            onClick={onCreateClick}
            className="flex items-center space-x-8 dr-cursor-pointer dr-text-darwin-touch-primary-primary"
          >
            <PlusRegularIcon className="w-12 h-12" />
            <div className="TouchCalloutBold">{createCta}</div>
          </div>
        ) : null}
      </div>
      <div className="dr-h-1 dr-bg-doctor-darwin-neutral-50" />
    </>
  );
};

export default PopoverHeader;
